import styled from "styled-components";

export const FormContainer = styled.div`
  margin-top: 16px;
  margin-bottom: 16px;
  background-color: ${({ theme }) => theme.colors.neutral.neutral05};
  padding: 15px;
  border-radius: 5px;
`;

export const TituloDropdown = styled.div`
  color: ${({ theme }) => theme.colors.neutral.neutral60};
  font-size: 15px;
  margin-bottom: 2px;
`;

export const TituloInput = styled.div`
  color: ${({ theme }) => theme.colors.neutral.neutral60};
  font-size: 15px;
  margin-bottom: 2px;
  margin-top: 24px;
`;

export const InstrucoesContainer = styled.div`
  color: ${({ theme }) => theme.colors.neutral.neutral70};
  font-size: 16px;
  margin-top: 12px;
  margin-bottom: 24px;
`;

export const CustomTextarea = styled.textarea`
  width: 100%;
  border: 1px solid ${({ theme }) => theme.colors.neutral.neutral20};
  border-radius: 5px;
  outline: none;
  padding: 2px 15px;
  height: 90px;

  &:focus {
    border: 1px solid ${({ theme }) => theme.colors.neutral.neutral20};
    outline: none;
    box-shadow: none;
  }
`;

export const ContainerCustomArea = styled.div`
  margin-top: 24px;
`;

export const ContarCaracteres = styled.div`
  color: ${({ theme }) => theme.colors.neutral.neutral60};
  font-size: 12px;
`;
